(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';
        var TrackingScriptName = 'GlamiTracking';

        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();
        var Tracker = LhApp.Function.Tracking.getTracker("glami", TrackingModel);

        if (!Tracker || !Tracker.Properties.TrackingGlamiId)
            return;

        if (!LhApp.Function.Tracking.canTrack()) {
            return;
        }

        var _cartAddResponses = []; // holds a response for every cart add action. 
        var _isUserSelectedProduct;

        Init();

        function Init() {
            (function (f, a, s, h, i, o, n) {
                f['GlamiTrackerObject'] = i;
                f[i] = f[i] || function () { (f[i].q = f[i].q || []).push(arguments) }; o = a.createElement(s),
                    n = a.getElementsByTagName(s)[0]; o.async = 1; o.src = h; n.parentNode.insertBefore(o, n)
            })(window, document, 'script', '//www.glami.gr/js/compiled/pt.js', 'glami');

            glami('create', Tracker.Properties.TrackingGlamiId, 'gr');

            //Track page view
            glami('track', 'PageView');

            //TRACK order completion
            if (TrackingModel.IsThankYouPage && TrackingModel.CartProductsData && TrackingModel.Order) {
                if (TrackingModel.Order.IsAlreadyTracked)
                    return;

                var orderproductIds = [];
                var orderNames = [];
                var categories = [];
                var items = TrackingModel.CartProductsData;
                for (var i = 0; i < items.length; i++) {
                    var product = items[i];
                    var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                    orderproductIds.push(productId);
                    categories.push(product.Category);
                    orderNames.push(product.Name);
                }

                glami('track', 'Purchase',
                    {
                        item_ids: orderproductIds,
                        product_names: orderNames,
                        value: TrackingModel.Order.TotalPrice,
                        currency: LhApp.Context.Currency.Code,
                        transaction_id: TrackingModel.Order.Id
                    });
            }  

            var extraProductListsTemplates = (Tracker.Properties.GlamiExtraProductListsTemplates || '').toLowerCase().split(',');
            //TRACK product list 
            if (TrackingModel.ProductListsData
                && (TrackingModel.IsProductListPage || extraProductListsTemplates.indexOf(LhApp.Context.Item.Template.toLowerCase()) >= 0)) {

                var items = _.flatten(_.toArray(TrackingModel.ProductListsData));

                var product_ids = [];
                for (var i = 0, len = items.length; i < len; i++) {
                    var product = items[i];
                    var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);
                    product_ids[product_ids.length] = productId;
                }

                glami('track', 'ViewContent', {
                    content_type: 'category',
                    item_ids: product_ids,
                    category_text: TrackingModel.Path.join(Tracker.Properties.GlamiCategoryTextSeperator || ' > ')
                });
            } else if (TrackingModel.IsProductDetailsPage && TrackingModel.ProductData && TrackingModel.ProductData.length > 0) {
                var product = TrackingModel.ProductData[0];
                var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                glami('track', 'ViewContent', {
                    content_type: 'product',
                    item_ids: [productId]
                });
            }
        }


        // IMPORTANT execute this scripts in all other pages except checout
        if (typeof (Vendd) != "undefined" && Vendd.Scripts) {

            Vendd.MessageBus.subscribe(Vendd.Product.Messages.SetSelected, TrackingScriptName, function (envelope) {
                //determine if this has been auto raised during product details load in order to avoid tracking twice the product view
                _isUserSelectedProduct = envelope.message.data.visitorInitiated;
            });
            //TRACK product view (changed)
            Vendd.MessageBus.subscribe(Vendd.Product.Messages.Changed, TrackingScriptName, function (envelope) {
                if (!_isUserSelectedProduct)
                    return;

                var model = envelope.message.data.model;

                var product = model;
                var productId = LhApp.Function.Tracking.getFeedItemId(product, 'ProductChanged', Tracker);

                glami('track', 'ViewContent', {
                    content_type: 'product',
                    item_ids: [productId]
                });
            });
            //HELPER this script keep track of products added to cart
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Add, TrackingScriptName, function (envelope) {
                var res = envelope.message.data;
                _cartAddResponses.push({
                    ProductId: res.id,
                    SkuId: res.skuId,
                    Quantity: parseFloat(res.qty)
                });

            });
            //TRACK add to cart (recorded by the ABOVE script)
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, TrackingScriptName, function (envelope) {
                var cartModel = envelope.message.data.Cart;

                var pAddResponse = _cartAddResponses.shift();
                (function AddToCartTrack(p) {
                    if (!p)
                        return;

                    var pCartItemModel = cartModel.Items.filter(function (i) {
                        return i.ProductId == p.ProductId && i.VariantId == p.SkuId;
                    })[0];

                    if (pCartItemModel) {
                        var product = pCartItemModel;
                        var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                        glami('track', 'AddToCart', {
                            item_ids: [productId],
                            product_names: pCartItemModel.Title,
                            value: pCartItemModel.Prices.PriceN,
                            currency: LhApp.Context.Currency.Code
                        });
                    }

                    AddToCartTrack(_cartAddResponses.shift());

                })(pAddResponse);

            });
        }
    });
})();